import React, { useState, useEffect, useContext } from 'react'
import DateService from 'live/services/date'
import { CasingAnnotationExtra, OperationAnnotationExtra } from '../types'
import api from '../../api'
import { __SOURCE_METADATA__ } from "../commom"
import { ContainerBody, Footer, FromDatePicker, Header, Selector, ToDatePicker, getUnixFromDateAndTime, getWellName, makeHisotry } from '../commom'
import { CASING_TYPE_KEY, metadataOptionsKeyTitle } from './MetadataOptions'
import { DashboardContext } from 'live/context/dashboard'
import Authorization from 'live/services/authorization'

const LOOKUP_KEY_1 = 'options_casing_type'
const LOOKUP_KEY_2 = 'options_casing_company'
const LOOKUP_KEY_3 = 'options_casing_size'

const CASING_COMPANY = 'casing_company'
const CASING_SIZE = 'casing_size'

function makeExtra(form, wellName) {
    const extra: CasingAnnotationExtra = {
        authorId: Authorization.user.id,
        author: Authorization.user.username,
        wellbore_name: wellName,
        [CASING_TYPE_KEY]: form[CASING_TYPE_KEY],
        metadata_type: CASING_TYPE_KEY
    }

    return extra
}

export default function ({ mode = 'temporal', event, onHide, ...props }) {
    console.log('operation ', props)
    if (mode !== 'temporal')
        return

    const beginValue = DateService.getMoment(parseInt(event.begin))
    const endValue = event.end !== null && event.end !== undefined ? DateService.getMoment(parseInt(event.end)) : null
    const { state, params, ...context } = useContext(DashboardContext)
    const [errors, setErrors] = useState({})
    const [options1, setOptions1] = useState([])
    const [options2, setOptions2] = useState([])
    const [options3, setOptions3] = useState([])
    const [colors, setColors] = useState({})
    const [form, setForm] = useState({
        [CASING_TYPE_KEY]: event?.extra?.[CASING_TYPE_KEY],
        [CASING_COMPANY]: event?.extra?.[CASING_COMPANY],
        [CASING_SIZE]: event?.extra?.[CASING_SIZE],
        fromDate: beginValue,
        fromTime: beginValue.format('HH:mm:ss'),
        toDate: endValue ?? null,
        toTime: !!endValue ? endValue.format('HH:mm:ss') : null
    })

    const wellName = getWellName(params.filter)

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal
        api.getLookupTable(signal, LOOKUP_KEY_1).then(r => {
            setOptions1([{value: null, label: null}, ...r.entries.map(({ key }) => ({ value: key, label: key }))])
            setColors(r.entries.reduce((map, p) => {
                map[p.key] = p.value
                return map
            }, {}))
        })

        api.getLookupTable(signal, LOOKUP_KEY_2).then(r => {
            setOptions2(r.entries.map(({ key }) => ({ value: key, label: key })))
            setColors(r.entries.reduce((map, p) => {
                map[p.key] = p.value
                return map
            }, {}))
        })

        api.getLookupTable(signal, LOOKUP_KEY_3).then(r => {
            setOptions3(r.entries.map(({ key }) => ({ value: key, label: key })))
            setColors(r.entries.reduce((map, p) => {
                map[p.key] = p.value
                return map
            }, {}))
        })
    }, [])

    function onSubmit() {
        const payload = {
            ...event,
            extra: makeExtra(form, wellName),
            uid: (event && event.uid) || undefined,
            begin: getUnixFromDateAndTime(form.fromDate, form.fromTime),
            end: !!form.toDate && !!form.toTime ? getUnixFromDateAndTime(form.toDate, form.toTime) : null,
            __src: __SOURCE_METADATA__,
            __color: colors[form[CASING_TYPE_KEY]],
            message: form[CASING_TYPE_KEY],
            activeDashboardFilters: props.activeDashboardFilters,
        }

        payload['extra']['history'] = makeHisotry(event, payload)

        api.createAnnotation(payload).then(e => {
            onHide()
        })
    }

    return <ContainerBody>
        <div className="timeline__form">
            <Selector label={metadataOptionsKeyTitle[CASING_TYPE_KEY]} property={CASING_TYPE_KEY} options={options1} form={form} setForm={setForm} />
            <Selector label={'CASING COMPANY'} property={CASING_COMPANY} options={options2} form={form} setForm={setForm} />
            <Selector label={'CASING SIZE'} property={CASING_SIZE} options={options3} form={form} setForm={setForm} />
            <FromDatePicker beginValue={beginValue} form={form} setForm={setForm} errors={errors} />
            <br />
            <ToDatePicker endValue={endValue} form={form} setForm={setForm} errors={errors} />
            <br />
            <Footer form={form} onSubmit={onSubmit} disabled={form[CASING_TYPE_KEY] == null || options1.length == 0} onHide={onHide} />
        </div>
    </ContainerBody>
}